import { useEffect, useRef, useState } from 'react';
import {
  CheckPointLocalStorage,
  CheckpointTypeFilterType,
} from '@/entities/checkpoint';
import { useLocalStorageState } from '../local-storage.hooks';
import debounce from 'lodash/debounce';

interface CheckPointFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useCheckPointFilter = ({
  setCurrentPage,
}: CheckPointFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] =
    useState<CheckpointTypeFilterType>({ key: '' });
  const filtersEmptyRef = useRef<boolean>(true);

  /**
   * === Filter section ===
   */
  const [key, setKey] = useLocalStorageState({
    key: CheckPointLocalStorage.KEY,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: CheckPointLocalStorage.STATUS,
    removeOnClose: true,
  });

  const [type, setType] = useLocalStorageState({
    key: CheckPointLocalStorage.TYPE,
    removeOnClose: true,
  });

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key,
      status,
      type,
    }));

    filtersEmptyRef.current = !key && !status && !type;
  }, [key, status, type]);

  const debounceFilterUpdate = (value: string) => {
    setKey(value);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const searchByType = (value: string) => {
    setType(value);
    setDebouncedFilter((prev) => ({ ...prev, type: value }));
  };

  const clearFilters = () => {
    setKey('');
    setStatus('');
    setType('');
    setCurrentPage(1);
  };
  /**
   * === END OF Filter section ===
   */

  return {
    debouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    type,
    status,
    debounceFilterUpdate,
    searchByStatus,
    searchByType,
  };
};
